export const organizationSchema = () => ({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'BUBO trans',
    'alternateName': 'Bubotrans',
    'url': 'https://bubotrans.cz',
    'logo': 'https://bubotrans.cz/shareimg.png',
    'description': 'Specialista na přepravu dokumentů, balíků a palet po celém světě.',
    'address': {
        '@type': 'PostalAddress',
        'streetAddress': 'Větrná 1041',
        'addressLocality': 'Beroun',
        'postalCode': '266 01',
        'addressCountry': 'CZ',
    },
    'sameAs': [
        'https://www.facebook.com/BUBOtrans/',
        'https://cz.linkedin.com/company/bubo-trans-s-r-o',
    ],
    'contactPoint': [{
        '@type': 'ContactPoint',
        'contactType': 'customer service',
        'telephone': '+420731345733',
        'availableLanguage': ['Czech', 'English'],
    }],
});
